var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.subscription && _vm.paid
    ? _c("div", { staticClass: "text-center" }, [
        _c("p", [
          _c("span", { staticClass: "display-block" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
          _vm._v(" "),
          _c(
            "strong",
            { staticClass: "display-block size-lg margin-top-2xs" },
            [_vm._v(_vm._s(_vm.nextPaymentDate))]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }